var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"h-100"},[(_vm.noDataFound)?_c('NoDataHtml'):_vm._e(),(!_vm.noDataFound)?_c('canvas',{staticClass:"p-4 position-relative",attrs:{"id":_vm.id}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }